import { render, staticRenderFns } from "./login-welcome-box.vue?vue&type=template&id=d276e3da"
import script from "./login-welcome-box.vue?vue&type=script&lang=js"
export * from "./login-welcome-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports